import { forwardRef } from 'react'
import Paper, { type PaperProps } from '@mui/material/Paper'
import { usePaperSlotProps } from '../../hooks/usePaperSlotProps/usePaperSlotProps'
import type { ModalSize, ModalPlacement } from '../../Modal.types'

export interface ModalPaperProps extends PaperProps {
  size?: ModalSize
  fullScreen?: boolean
  placement?: ModalPlacement
}

export const ModalPaper = forwardRef<HTMLDivElement, ModalPaperProps>(
  ({ size, fullScreen, placement, ...props }, ref) => {
    const paperSlotProps = usePaperSlotProps({ size, fullScreen, placement, slotProps: props })

    return <Paper ref={ref} {...paperSlotProps} />
  },
)

ModalPaper.displayName = 'ModalPaper'
